const esPlays = {
  playStatusPending: 'En cola',
  playStatusAccepted: 'Aval',
  playStatusFailed: 'Rechazada',
  playStatusOpen: 'Aceptada',
  playStatusRejected: 'Rechazada',
  playStatusWon: 'Ganadora',
  playStatusExpired: 'Expirada',
  /** @deprecated legacy seed/docs — display as Expirada */
  playStatusLost: 'Expirada',
  playStatusAnnulled: 'Anulada',
  playMgmtMenu: 'Gestionar jugada',
  playMgmtAnnul: 'Anular',
  playMgmtEdit: 'Cambiar monto',
  playMgmtPromote: 'Pasar al siguiente turno',
  playMgmtReason: 'Motivo',
  playMgmtReasonHint: 'Elige un motivo. Puedes añadir una nota breve.',
  playMgmtEditHint: 'Solo se puede cambiar el monto. El número no se modifica.',
  playMgmtPromoteHint: 'La jugada pasará al siguiente turno de aceptación.',
  playMgmtNoteOptional: 'Nota (opcional)',
  playMgmtNotePlaceholder: 'Detalle breve…',
  playMgmtAnnulWarn: 'La jugada quedará anulada y no se liquidará.',
  playMgmtPromoteWarn: 'Se transferirá al siguiente turno (mismo número y monto).',
  playMgmtNearCloseHint: 'Cerca del cierre los cambios pueden rechazarse. Confirma que se guardaron.',
  playMgmtConfirm: 'Confirmar',
  playMgmtSavedTitle: 'Cambio guardado',
  playMgmtSavedAnnul: 'La jugada fue anulada correctamente.',
  playMgmtSavedEdit: 'El monto fue actualizado correctamente.',
  playMgmtSavedPromote: 'La jugada pasó al siguiente turno.',
  playMgmtReason_client_request: 'Pedido del cliente',
  playMgmtReason_wrong_stake: 'Monto incorrecto',
  playMgmtReason_duplicate: 'Duplicada',
  playMgmtReason_risk_limit: 'Límite de riesgo',
  playMgmtReason_partial_cancel: 'Cancelación parcial',
  playMgmtReason_promote_next: 'Pasar al siguiente turno',
  playMgmtReason_other: 'Otro',
  error_play_not_open: 'Solo se pueden gestionar jugadas abiertas.',
  error_invalid_reason: 'Motivo inválido.',
  error_invalid_action: 'Acción inválida.',
  error_no_change: 'No hay cambios que guardar.',
  error_missing_caps: 'Faltan topes de la casa.',
  error_promote_unavailable: 'No se pudo determinar el siguiente turno.',
  playsTurnCurrent: 'Hoy',
  playsHistory: 'Histórico',
  playsArchived: 'Archivados',
  playsHistoryEmpty: 'Sin jugadas esta semana fuera de hoy.',
  playsArchivedEmpty: 'Sin jugadas archivadas.',
  playsTurnEmpty: 'Sin jugadas en este turno.',
  playsTurnBetween: 'Sin jugadas hoy todavía. El espacio queda libre para el próximo turno.',
  playsTurnDay: 'Día',
  playsTurnNight: 'Noche',
  submitConfirmOnlyWhenAccepted: 'Confirma al cliente solo cuando veas Aval.',
  submitQueued: 'En cola…',
  submitAccepted: '¡Aval emitido!',
  playClaimCode: 'Código',
  playClaimCodeCopy: 'Copiar código del Aval',
  playClaimCodeReveal: 'Ver código del Aval',
  playBuyerNote: 'Nota (opcional)',
  playBuyerNotePlaceholder: 'Nombre de quien juega…',
  playBuyerNoteMissing: 'Sin nota de nombre',
  playPayTitle: 'Cobrar premio',
  playPayHint: 'Pide el código del Aval y confirma que el nombre coincide.',
  playPayConfirm: 'Marcar pagado',
  playPayAction: 'Cobrar',
  playPayNameMatch: 'El nombre registrado coincide',
  playPaySavedTitle: 'Premio cobrado',
  playPaySavedBody: 'La jugada quedó marcada como pagada.',
  playPaid: 'Pagado',
  playUnpaid: 'Por pagar',
  playClaimSearch: 'Buscar por código o nota…',
  playSpecialRateHint: 'Tope o tarifa especial para este número',
  payoutRatesSection: 'Premios',
  payoutRatesHint: 'Multiplicadores de la casa. Las jugadas ya tomadas no cambian.',
  numberConstraintsSection: 'Acotes de números',
  numberConstraintsHint: 'Bajan tope o tarifa de forma temporal. Nunca suben las tarifas de Config.',
  numberCapsPermanent: 'Topes permanentes por número',
  numberCapsHint: 'Tope de exposición fijo para un número. El más bajo entre permanente, saturación y acote gana.',
  constraintNumbers: 'Números',
  constraintCap: 'Tope $',
  constraintSchedule: 'Vigencia',
  constraintScheduleDraws: 'N tiradas',
  constraintScheduleDays: 'N días',
  constraintScheduleRange: 'Rango de fechas',
  constraintScheduleSeason: 'Temporada (cada año)',
  constraintCount: 'Cantidad',
  constraintStart: 'Inicio',
  constraintEnd: 'Fin',
  constraintNote: 'Nota',
  constraintAdd: 'Añadir acote',
  constraintDisable: 'Desactivar',
  seatQuotaBlocked: 'Sin plazas de personal',
  seatQuotaBlockedHint: 'Este plan no admite más listers, runners o bankers. Mejora el plan o quita un usuario.',
  error_play_not_won: 'Solo se cobran jugadas ganadoras.',
  error_play_already_paid: 'Este premio ya se cobró.',
  error_play_claim_mismatch: 'El código del Aval no coincide.',
  error_play_no_payout: 'Esta jugada no tiene premio.',
  error_play_not_found: 'No encontramos esa jugada.',
  error_invalid_constraint: 'El acote no es válido.',
  error_constraint_empty: 'Indica un tope o una tarifa más baja.',
  error_constraint_rate_above_house: 'La tarifa del acote no puede superar la de la casa.',
  error_constraint_not_found: 'No encontramos ese acote.',
  resultsWaitFrom: 'Desde',
  resultsWaitTo: 'Hasta',
  acceptancePreview: 'Acepta jugadas {open} → {close} (Cuba)',
  clockCuba: 'Cuba',
  clockLocal: 'Tu hora',
  waitingNextTurn: 'Entre turnos',
  acceptingWhileAwaitingPrev: 'Aceptando · resultados pendientes',
  delayedResultsHint: 'Ya se aceptan jugadas de este turno; aún faltan resultados del turno anterior.',
  publishFirstPrizeHint: '1ro: 2 dígitos (fijo) o 3 (Pick 3 → fijo + centena).',
  publishFirstPrizeAria: 'Primer premio (2 o 3 dígitos)',
  resultsHistoryLoadFailed: 'No se pudieron cargar sorteos anteriores. Toca para reintentar.',
  resultsFeedLoading: 'Cargando resultados…',
  resultsFeedRetryHint: 'Toca para reintentar.',
};

export default esPlays;
